import { Button, Modal } from "@/shared/ui";

import CardSuccessImg from "@/assets/images/card-success.png";

interface IProps {
    open: boolean;
    onContinue(): void;
};

const AddCardSuccess = ({ open, onContinue }: IProps) => (
    <Modal
        open={open}
        contentClassName="sm:max-w-[511px] md:!py-[50px] py-[30px] px-[20px]"
        defaultContentSizes={false}
        onClose={onContinue}
    >
        <div className="items-centers flex flex-col">
            <img width={100} src={CardSuccessImg} alt="" className="mx-auto w-[6.125rem] mb-1" />

            <h2 className="w-full text-[1.5625rem] text-center mb-[0.625rem] font-agrandir">
                Your card has been
                <br />
                added successfully!
            </h2>

            <p className="w-full font-atkinsonHyperlegible text-center mb-5">
                Your first monthly payment will be processed
                <br />
                once your MedBox ships.
            </p>

            <Button
                showEndIcon
                onClick={onContinue}
                fontClassName="font-atkinsonBold"
            >
                <span>Continue</span>
            </Button>
        </div>
    </Modal>
);

export default AddCardSuccess;